import * as React from 'react';

import { DataListContain, DataRow, DataCell } from '../Tables/DataList';
import QuestionnaireListItem from './QuestionnaireListItem';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchAll } from '../../app/store/questionnaireSlice';
import { Questionnaire } from '../../interfaces/questionnaire.interface';
import { useState } from 'react';
import StandardModal from '../Modals/StandardDialog';
import QuestionnaireForm from './QuestionnaireForm';
import { FormLabel, Switch, TablePagination } from '@mui/material';

export default function QuestionnaireManagement() {
  const { user } = useAppSelector(state =>  state.user);
  const dispatch = useAppDispatch();
  const questionnaires: Questionnaire[] = useAppSelector(state => state.questionnaires.results);
  const totalCount: number = useAppSelector(state => state.questionnaires.count);
  const [newOpen, setNewOpen] = useState(false);
  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);
  const [fetchUnpublished, setFetchUnpublished] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  // Server-side pagination: child questionnaires are nested under their parents,
  // so the page requests top-level rows only.
  const listArgs = React.useMemo(() => ({
    unpublished: fetchUnpublished ? undefined : true,
    limit: rowsPerPage,
    offset: page * rowsPerPage,
    parentsOnly: true,
  }), [fetchUnpublished, page, rowsPerPage]);

  React.useEffect(() => {
    dispatch(fetchAll(listArgs));
  }, [listArgs]);

  React.useEffect(() => {
    setPage(0);
  }, [fetchUnpublished]);

  const refreshList = () => {
    dispatch(fetchAll(listArgs));
  };

  const canEdit = React.useMemo(() => user?.permissions?.includes('can_edit_questionnaires'), [user]);

  return (
    <>
      <StandardModal title='New Questionnaire' isOpen={newOpen} handleClose={handleNewClose} >
        <QuestionnaireForm handleClose={handleNewClose} refresh={refreshList} />
      </StandardModal>
      <DataListContain title="Questionnaires" buttonTitle={canEdit ? 'Questionnaire' : ''} buttonClick={() => handleNewOpen()}>
        <FormLabel sx={{ position: 'absolute', right: '215px', top: '-55px' }}>Show Unpublished Questionnaires
          <Switch onChange={() => setFetchUnpublished(!fetchUnpublished)} defaultChecked={fetchUnpublished} />
        </FormLabel>
        <DataRow header>
          <DataCell xs={1}>Version</DataCell>
          <DataCell xs={1}>Sort Order</DataCell>
          <DataCell xs={3}>Title</DataCell>
          <DataCell xs={2}>Description</DataCell>
          <DataCell xs={1}>Published</DataCell>
          <DataCell xs={2}>Type</DataCell>
          <DataCell xs={2}>Domains</DataCell>
        </DataRow>
        {questionnaires.map((questionnaire: Questionnaire, idx: number) => <QuestionnaireListItem canEdit={canEdit} key={questionnaire.id} idx={idx} questionnaire={questionnaire} refresh={refreshList} />) }
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={(_e, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </DataListContain>
    </>
  );
}
